<template>
  <Navigation :currentPage="'upload'" />

  <div class="catelouge">
    <h4>资源上传说明</h4>
    <ul>
        <li @click="scrollToSection('unitsSetup')" :class="{ active: activeSection === 'unitsSetup' }">核对单位和尺寸</li>
        <li @click="scrollToSection('mapSetup')" :class="{ active: activeSection === 'mapSetup' }">设置贴图路径</li>
        <li @click="scrollToSection('groupSetup')" :class="{ active: activeSection === 'groupSetup' }">资源分组</li>
        <li @click="scrollToSection('directionSetup')" :class="{ active: activeSection === 'directionSetup' }">调整模型方向</li>
        <li @click="scrollToSection('collapse')" :class="{ active: activeSection === 'collapse' }">资源塌陷</li>
        <li @click="scrollToSection('creatRes')" :class="{ active: activeSection === 'creatRes' }">创建资源</li>
        <li @click="scrollToSection('renderPreview')" :class="{ active: activeSection === 'renderPreview' }">渲染缩略图</li>
        <li @click="scrollToSection('uploadRes')" :class="{ active: activeSection === 'uploadRes' }">上传资源</li>
    </ul>
  </div>  

  <div id="videoHeader">
    <video
      src="@/assets/video/upload_header.mp4" 
      autoplay
      muted
      loop
    >
    您的浏览器不支持 HTML5 视频标签。
    </video>
  </div>
  <div class="upload">
  
    <div class="notes">
      <div class="circle">半分钟</div>
      <h1>创建您的专属资源库，让设计越来越顺手。</h1>
      <h1 id="autoUp">自动处理模型、贴图，批量生成文件、缩略图。</h1>
      <h1 id="autoUp">管理资源简单方便。</h1>
    </div>

    <UpGuide/>
    <ul class="footer">
        <li>本站对用户上传资源的知识产权状况仅负有形式审查义务</li>
        <li>本站有权根据权利人提供的有效投诉材料，对涉嫌侵权资源进行先行处理</li>
        <li>在处理侵权纠纷时，本站有权要求用户提供相关权利证明文件</li>
        <li>沪ICP备2025143786号-2</li>
    </ul>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue'
import PluginsList from '@/components/PluginsList.vue'
import UpGuide from '@/components/UpGuide.vue'

export default {
  name: 'UploadView',
  components: {
    Navigation,
    PluginsList,
    UpGuide,
  },

  data() {
    return {
      activeSection: 'unitsSetup' // 默认激活第一个
    }
  },

  mounted() {
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('scroll', this.handleSectionActivation);
  },

  beforeUnmount() {
    // 组件销毁时移除监听，避免内存泄漏
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('scroll', this.handleSectionActivation);
  },

  methods: {
    handleScroll() {
      const element = document.querySelector('.catelouge');
      const triggerPosition = 1400; // 滚动到200px时显示
      
      if (window.scrollY > triggerPosition) {
        element.classList.add('show');
      } else {
        element.classList.remove('show');
      }
    },

    handleSectionActivation() {
      const sections = [
        'unitsSetup', 'mapSetup', 'groupSetup', 'directionSetup', 
        'collapse', 'creatRes', 'renderPreview', 'uploadRes'
      ];
      
      const offset = 360; // 激活偏移量
      
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= offset) {
            this.activeSection = sections[i];
            break;
          }
        }
      }
    },

    scrollToSection(sectionId){
      this.activeSection = sectionId;
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 84; // 微调距离，根据需要调整
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - offset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  }
}
</script>

<style>
.catelouge{
  position: fixed;
  padding: 24px;
  z-index: 1000;
  background-color: white;
  border-right: rgb(240, 240, 240) solid 1px;
  height: 100%;
  opacity: 0;
  transform: translateY(-20px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.catelouge.show {
  opacity: 1;
  transform: translateY(0);
}

.catelouge h4{
  border-bottom: lightgray solid 1px;
  font-size: 16px;
  color: #45B5B5;
  line-height: 48px;
}

.catelouge li{
  font-size: 16px;
  color: rgb(180, 180, 180);
  line-height: 28px;
  list-style-type: none;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.5, 0.46, 0.45, 0.94);
}

.catelouge li:hover{
  color: black;
}

.catelouge li.active {
  color: black;
  font-weight: 400;
  border-bottom: none;
}

.upload{
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  min-width: 1024px;
}

#autoUp{
  font-size: 48px;
}

</style>